// import { useEffect, useState } from "react";
// import dayjs from "dayjs";
// import {
//   Button,
//   Flex,
//   message,
//   Table,
//   Input,
//   DatePicker,
//   TreeSelect,
//   Spin,
//   Popconfirm,
// } from "antd";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   FolderOpenOutlined,
// } from "@ant-design/icons";
// import {
//   fetchExecutions,
//   deleteExecution,
// } from "../service/qualityChecklistExecution";
// import { useNavigate } from "react-router-dom";
// import { fetchBuilders } from "../../QualityConfiguration/QualityChecklistConfiguration/Service/qualityProcedureBuilder";
// import { fetchProduct } from "../../../../configuration/module/Product/Service/product";
// import { buildTreeData } from "../../../../configuration/module/Product/Component/product";

// const { RangePicker } = DatePicker;

// const QualityPlanChecklistExecution = () => {
//   const [executions, setExecutions] = useState([]);
//   const [builders, setBuilders] = useState([]);
//   const [productList, setProductList] = useState([]);

//   // pagination
//   const [page, setPage] = useState(1);
//   const [size, setSize] = useState(10);
//   const [total, setTotal] = useState(0);

//   // filters
//   const [serialNumber, setSerialNumber] = useState(undefined);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [dateRange, setDateRange] = useState([]);

//   // sorting
//   const [sortField, setSortField] = useState("createdAt");
//   const [sortOrder, setSortOrder] = useState("descend");

//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();

//   // ================= FETCH =================
//   const fetchData = async (
//     pageNum = page,
//     pageSize = size,
//     field = sortField,
//     order = sortOrder
//   ) => {
//     setLoading(true);
//     try {
//       const res = await fetchExecutions({
//         page: pageNum - 1,
//         size: pageSize,
//         search: serialNumber || undefined,
//         productId: selectedProduct || undefined,
//         fromDate: dateRange?.length === 2 ? dateRange[0] : undefined,
//         toDate: dateRange?.length === 2 ? dateRange[1] : undefined,
//         sort: field,
//         desc: order === "descend",
//       });

//       setExecutions(res.data?.content || []);
//       setTotal(res.data?.totalElements || 0);
//       setPage(pageNum);
//       setSize(pageSize);
//       setSortField(field);
//       setSortOrder(order);
//     } catch {
//       message.error("Error fetching executions");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ================= INIT =================
//   useEffect(() => {
//     fetchData();

//     fetchBuilders()
//       .then((res) => setBuilders(res.data || []))
//       .catch(() => message.error("Error fetching builders"));

//     fetchProduct()
//       .then((res) => setProductList(buildTreeData(res.data)))
//       .catch(() => message.error("Error fetching products"));
//   }, []);

//   // ================= ACTIONS =================
//   const deleteData = async (id) => {
//     try {
//       await deleteExecution(id);
//       message.success("Execution deleted successfully");
//       fetchData(page, size);
//     } catch {
//       message.error("Error deleting execution");
//     }
//   };

//   const applyFilters = () => {
//     fetchData(1, size);
//   };

//   const resetFilters = () => {
//     setSerialNumber("");
//     setSelectedProduct(null);
//     setDateRange([]);
//     fetchData(1, size);
//   };

//   // ================= COLUMNS =================
//   const columns = [
//     {
//       title: "Serial Number",
//       dataIndex: "serialNumber",
//       key: "serialNumber",
//       sorter: true,
//       sortOrder: sortField === "serialNumber" ? sortOrder : null,
//     },
//     {
//       title: "Product",
//       dataIndex: "checklistId",
//       key: "product",
//       sorter: true,
//       sortOrder: sortField === "checklistId" ? sortOrder : null,
//       render: (id) => builders.find((b) => b.id === id)?.productName || "-",
//     },
//     {
//       title: "Checklist",
//       dataIndex: "checklistId",
//       key: "checklist",
//       sorter: true,
//       sortOrder: sortField === "checklistId" ? sortOrder : null,
//       render: (id) => builders.find((b) => b.id === id)?.checklistName || "-",
//     },
//     {
//       title: "Created At",
//       dataIndex: "createdAt",
//       key: "createdAt",
//       sorter: true,
//       sortOrder: sortField === "createdAt" ? sortOrder : null,
//       render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm:ss") : "-"),
//     },
//     {
//       title: "Updated At",
//       dataIndex: "updatedAt",
//       key: "updatedAt",
//       sorter: true,
//       sortOrder: sortField === "updatedAt" ? sortOrder : null,
//       render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm:ss") : "-"),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       align: "center",
//       render: (_, record) => (
//         <>
//           <FolderOpenOutlined
//             style={{ marginRight: 12, cursor: "pointer" }}
//             onClick={() => navigate(`view/${record.id}`)}
//           />
//           <EditOutlined
//             style={{ marginRight: 12, cursor: "pointer" }}
//             onClick={() => navigate(`edit/${record.id}`)}
//           />
//           <Popconfirm
//             title="Delete record"
//             description="Are you sure you want to delete this record?"
//             okText="Yes"
//             cancelText="No"
//             okType="danger"
//             placement="left"
//             onConfirm={() => deleteData(record.uuid)}
//           >
//             <DeleteOutlined style={{ cursor: "pointer" }} />
//           </Popconfirm>
//         </>
//       ),
//     },
//   ];

//   return (
//     <Spin spinning={loading}>
//       <div>
//         <Flex
//           justify="space-between"
//           align="center"
//           style={{ marginBottom: 16 }}
//         >
//           <div style={{ fontSize: "1rem", fontWeight: 700 }}>
//             Checklist Execution
//           </div>
//         </Flex>

//         {/* Filters */}
//         <Flex gap={12} style={{ marginBottom: 16, flexWrap: "wrap" }}>
//           <Input
//             placeholder="Search"
//             value={serialNumber}
//             onChange={(e) => setSerialNumber(e.target.value)}
//             style={{ width: 200 }}
//           />

//           <TreeSelect
//             value={selectedProduct}
//             onChange={setSelectedProduct}
//             treeData={productList}
//             placeholder="Select product"
//             allowClear
//             style={{ width: 220 }}
//           />

//           <RangePicker
//             value={dateRange}
//             onChange={setDateRange}
//             style={{ width: 260 }}
//           />

//           <Button type="primary" onClick={applyFilters}>
//             Apply
//           </Button>
//           <Button onClick={resetFilters}>Reset</Button>

//           <Flex flex={1} justify="end">
//             <Button
//               type="primary"
//               style={{ fontWeight: 600 }}
//               onClick={() => navigate("add")}
//             >
//               + Add
//             </Button>
//           </Flex>
//         </Flex>

//         {/* Table */}
//         <Table
//           rowKey="id"
//           columns={columns}
//           dataSource={executions}
//           bordered
//           scroll={{ x: "max-content" }}
//           pagination={{
//             current: page,
//             pageSize: size,
//             total,
//             showSizeChanger: true,
//             pageSizeOptions: ["10", "20", "50", "100"],
//           }}
//           onChange={(pagination, filters, sorter) => {
//             const field = sorter.field || sortField;
//             const order = sorter.order || sortOrder;

//             fetchData(pagination.current, pagination.pageSize, field, order);
//           }}
//         />
//       </div>
//     </Spin>
//   );
// };

// export default QualityPlanChecklistExecution;

import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  Button, Flex, message, Table, Input, DatePicker, TreeSelect, Spin, Popconfirm,
} from "antd";
import { EditOutlined, DeleteOutlined, FolderOpenOutlined } from "@ant-design/icons";
import { fetchExecutions, deleteExecution } from "../service/qualityChecklistExecution";
import { useNavigate } from "react-router-dom";
import { fetchBuilders } from "../../QualityConfiguration/QualityChecklistConfiguration/Service/qualityProcedureBuilder";
import { fetchProduct } from "../../../../configuration/module/Product/Service/product";
import { buildTreeData } from "../../../../configuration/module/Product/Component/product";
import usePermission from "../../../../hooks/usePermission";

const { RangePicker } = DatePicker;

const QualityPlanChecklistExecution = () => {
  const { canCreate, canUpdate, canDelete } = usePermission("QUALITY_EXECUTION");

  const [executions, setExecutions] = useState([]);
  const [builders, setBuilders] = useState([]);
  const [productList, setProductList] = useState([]);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [serialNumber, setSerialNumber] = useState(undefined);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [dateRange, setDateRange] = useState([]);
  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("descend");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchData = async (pageNum = page, pageSize = size, field = sortField, order = sortOrder) => {
    setLoading(true);
    try {
      const res = await fetchExecutions({
        page: pageNum - 1, size: pageSize,
        search: serialNumber || undefined,
        productId: selectedProduct || undefined,
        fromDate: dateRange?.length === 2 ? dateRange[0] : undefined,
        toDate: dateRange?.length === 2 ? dateRange[1] : undefined,
        sort: field, desc: order === "descend",
      });
      setExecutions(res.data?.content || []);
      setTotal(res.data?.totalElements || 0);
      setPage(pageNum); setSize(pageSize); setSortField(field); setSortOrder(order);
    } catch { message.error("Error fetching executions"); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    fetchData();
    fetchBuilders().then((res) => setBuilders(res.data || [])).catch(() => message.error("Error fetching builders"));
    fetchProduct().then((res) => setProductList(buildTreeData(res.data))).catch(() => message.error("Error fetching products"));
  }, []);

  const deleteData = async (id) => {
    try {
      await deleteExecution(id);
      message.success("Execution deleted successfully");
      fetchData(page, size);
    } catch { message.error("Error deleting execution"); }
  };

  const columns = [
    { title: "Serial Number", dataIndex: "serialNumber", key: "serialNumber", sorter: true, sortOrder: sortField === "serialNumber" ? sortOrder : null },
    { title: "Product", dataIndex: "checklistId", key: "product", render: (id) => builders.find((b) => b.id === id)?.productName || "-" },
    { title: "Checklist", dataIndex: "checklistId", key: "checklist", render: (id) => builders.find((b) => b.id === id)?.checklistName || "-" },
    { title: "Created At", dataIndex: "createdAt", key: "createdAt", sorter: true, sortOrder: sortField === "createdAt" ? sortOrder : null, render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm:ss") : "-") },
    { title: "Updated At", dataIndex: "updatedAt", key: "updatedAt", sorter: true, sortOrder: sortField === "updatedAt" ? sortOrder : null, render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm:ss") : "-") },
    {
      title: "Actions", key: "actions", align: "center",
      render: (_, record) => (
        <>
          <FolderOpenOutlined style={{ marginRight: 12, cursor: "pointer" }} onClick={() => navigate(`view/${record.id}`)} />
          {canUpdate && <EditOutlined style={{ marginRight: 12, cursor: "pointer" }} onClick={() => navigate(`edit/${record.id}`)} />}
          {canDelete && (
            <Popconfirm title="Delete record" description="Are you sure?" okText="Yes" cancelText="No" okType="danger" placement="left" onConfirm={() => deleteData(record.uuid)}>
              <DeleteOutlined style={{ cursor: "pointer" }} />
            </Popconfirm>
          )}
        </>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div>
        <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
          <div style={{ fontSize: "1rem", fontWeight: 700 }}>Quality Plan Execution</div>
        </Flex>
        <Flex gap={12} style={{ marginBottom: 16, flexWrap: "wrap" }}>
          <Input placeholder="Search" value={serialNumber} onChange={(e) => setSerialNumber(e.target.value)} style={{ width: 200 }} />
          <TreeSelect value={selectedProduct} onChange={setSelectedProduct} treeData={productList} placeholder="Select product" allowClear style={{ width: 220 }} />
          <RangePicker value={dateRange} onChange={setDateRange} style={{ width: 260 }} />
          <Button type="primary" onClick={() => fetchData(1, size)}>Apply</Button>
          <Button onClick={() => { setSerialNumber(""); setSelectedProduct(null); setDateRange([]); fetchData(1, size); }}>Reset</Button>
          {canCreate && (
            <Flex flex={1} justify="end">
              <Button type="primary" style={{ fontWeight: 600 }} onClick={() => navigate("add")}>+ Add</Button>
            </Flex>
          )}
        </Flex>
        <Table rowKey="id" columns={columns} dataSource={executions} bordered scroll={{ x: "max-content" }}
          pagination={{ current: page, pageSize: size, total, showSizeChanger: true, pageSizeOptions: ["10", "20", "50", "100"] }}
          onChange={(pagination, _, sorter) => fetchData(pagination.current, pagination.pageSize, sorter.field || sortField, sorter.order || sortOrder)}
        />
      </div>
    </Spin>
  );
};

export default QualityPlanChecklistExecution;